import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';
import { CoreModule, I18nService } from '@app/core';
import { SharedModule } from '@app/shared';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { V2Module } from '@app/_v2/v2.module';
import { CountryRestrictionModule } from '@app/country-restriction/country-restriction.module';
import { RedirectComponent } from '@app/redirect.component';
import { ImpersonateComponent } from '@app/impersonate.component';
import { PlayerService } from '@app/player.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { CryptoPipe } from '@app/shared/pipes/crypto.pipe';
import { HelpersService } from '@app/services/helpers.service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    HttpModule,
    TranslateModule.forRoot(),
    NgbModule.forRoot(),
    CoreModule,
    SharedModule,
    AppRoutingModule,
    CountryRestrictionModule,
    V2Module,
  ],
  exports: [
    // CoreModule,
    // SharedModule,
  ],
  declarations: [AppComponent, RedirectComponent, ImpersonateComponent],
  providers: [PlayerService, CurrencyPipe, DecimalPipe, CryptoPipe, HelpersService],
  // providers: [ { provide: ErrorHandler, useClass: RavenErrorHandler } ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/app.module.ts